/**
 * @file index.tsx
 *
 * @fileoverview Job search utility functions.
 */

/**
 * Removes unwanted things from the querystring of the current URL.
 */
export const removeUnusedItemsFromUrl = (url: string) => {
  if (url.split('?').length === 1) {
    return url;
  }

  const querystring = new URLSearchParams(url.split('?')[1]);
  const unusedItems = [];
  unusedItems.forEach((item) => querystring.delete(item));
  const searchParamsLength = Array.from(querystring.values())?.length;

  return `${url.split('?')[0]}${
    searchParamsLength === 0 ? '' : '?'
  }${querystring.toString()}`;
};
